import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import './assets/style/index.css';
import './assets/style/react-toastify-style.css';
import { BrowserRouter } from 'react-router-dom';
import './i18n';
import { HelmetProvider } from 'react-helmet-async';

ReactDOM.createRoot(document.getElementById('root')).render(
  <HelmetProvider>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </HelmetProvider>
);

// Initialize Sentry after first render to not block initial paint
if ('requestIdleCallback' in window) {
  requestIdleCallback(() => import('./instrument.js'));
} else {
  setTimeout(() => import('./instrument.js'), 2000);
}
